import * as checked from 'reporting-data/lib/checked';
import { Dataset } from 'reporting-data/v2/dataset/datasetRecords';
import { WATERFALL } from '../../constants/visualizationTypes';
const AxisEncoding = checked.record({
  field: checked.string()
}, 'AxisEncoding');
const Layer = checked.record({
  dataset: checked.string(),
  x: AxisEncoding,
  y: AxisEncoding,
  onClick: checked.func()
}, 'Layer');
export const WaterfallVisualization = checked.record({
  type: checked.string().always(WATERFALL),
  data: checked.map(Dataset),
  layer: Layer
}, 'WaterfallVisualization');